import ExtraStatusService from '../../../services/extra-status.service'
import EventBus from '../../../EventBus';

export default {
  methods: {
    async setUnsetExtraStatus(orderId, extraStatusId, action){
      


      this.$dialog
      .confirm('Please confirm to proceed')
      .then(async (dialog) => {
        
        let queryResult;
        if(action == 'add'){

          queryResult = await ExtraStatusService.addExtraStatus({
             recordId: orderId,
             extraStatusId
           })
          console.log(queryResult.data.message)
        }
        else{
            queryResult = await ExtraStatusService.removeExtraStatus( orderId, extraStatusId)
            console.log(queryResult.data.message)
        }
  
  
        this.$toasted.show(queryResult.data.message, {
              type: "info",
              duration: 1000,
              action: {
                text: "Close",
                class: "toastBtnTxt",
                onClick: (e, toastObject) => {
                  toastObject.goAway(0);
                },
              },
              duration: 5000,
          });
  
  
          EventBus.$emit("extra-status-modified", queryResult.data.theOrder)

      })
      .catch(() => {
        console.log('Clicked on cancel');
      });

      
    }
  }
}